module.exports = __webpack_public_path__ + "static/img/aqzs32.61fb4285.jpg";